import { observer } from 'mobx-react-lite'
import { AgentKnowledgeBase } from 'pages/chatbot/ui/AgentKnowledgeBase/AgentKnowledgeBase'
import { useAICallingAgentManageContext } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/context'

export const AIKnowledgeBase = observer(() => {
  const {
    aiKnowledgeBaseStore: {
      agentKnowledgeBaseStore,
      setKnowledgeBaseUsage,
      knowledgeBaseUsage,
      knowledgeBaseDocuments,
      setKnowledgeBaseDocuments,
      knowledgeBaseDocumentsError,
      setKnowledgeBaseDocumentsError,
    },
  } = useAICallingAgentManageContext()

  return (
    <AgentKnowledgeBase
      agentKnowledgeBaseStore={agentKnowledgeBaseStore}
      knowledgeBaseDocumentsError={{
        message: knowledgeBaseDocumentsError,
        resetError: () => setKnowledgeBaseDocumentsError(''),
      }}
      setKnowledgeBaseUsage={setKnowledgeBaseUsage}
      knowledgeBaseUsage={knowledgeBaseUsage}
      setKnowledgeBaseDocuments={setKnowledgeBaseDocuments}
      knowledgeBaseDocuments={knowledgeBaseDocuments}
      errorType={'text'}
    />
  )
})
